import CopyQuestion from './copyQuestion'
export default CopyQuestion
